import React from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';
import { useAppColors } from '../context/PreferencesContext';

type Props = {
  color?: string;
  size?: number;
  thickness?: number;
  inset?: number;
  style?: ViewStyle;
};

/**
 * L-shaped focus markers in each corner of a face preview frame.
 */
export function FaceGuideCorners({
  color,
  size = 28,
  thickness = 3,
  inset = 14,
  style,
}: Props) {
  const palette = useAppColors();
  const stroke = color ?? palette.success;

  return (
    <View pointerEvents="none" style={[StyleSheet.absoluteFill, style]}>
      <View
        style={[
          styles.corner,
          styles.topLeft,
          {
            top: inset,
            left: inset,
            width: size,
            height: size,
            borderColor: stroke,
            borderTopWidth: thickness,
            borderLeftWidth: thickness,
          },
        ]}
      />
      <View
        style={[
          styles.corner,
          styles.topRight,
          {
            top: inset,
            right: inset,
            width: size,
            height: size,
            borderColor: stroke,
            borderTopWidth: thickness,
            borderRightWidth: thickness,
          },
        ]}
      />
      <View
        style={[
          styles.corner,
          styles.bottomLeft,
          {
            bottom: inset,
            left: inset,
            width: size,
            height: size,
            borderColor: stroke,
            borderBottomWidth: thickness,
            borderLeftWidth: thickness,
          },
        ]}
      />
      <View
        style={[
          styles.corner,
          styles.bottomRight,
          {
            bottom: inset,
            right: inset,
            width: size,
            height: size,
            borderColor: stroke,
            borderBottomWidth: thickness,
            borderRightWidth: thickness,
          },
        ]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  corner: {
    position: 'absolute',
  },
  topLeft: {
    borderTopLeftRadius: 4,
  },
  topRight: {
    borderTopRightRadius: 4,
  },
  bottomLeft: {
    borderBottomLeftRadius: 4,
  },
  bottomRight: {
    borderBottomRightRadius: 4,
  },
});
